/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Challenge_WorkoutsInputs */

const en_us2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workouts`)
};

const pt_br2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos`)
};

const es_419_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamientos`)
};

const pt_pt2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos`)
};

const fr_fr2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances`)
};

const de_de2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainings`)
};

const it_it2_clubs_challenge_workouts = /** @type {(inputs: Clubs_Challenge_WorkoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamenti`)
};

/**
* | output |
* | --- |
* | "Workouts" |
*
* @param {Clubs_Challenge_WorkoutsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_challenge_workouts = /** @type {((inputs?: Clubs_Challenge_WorkoutsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Challenge_WorkoutsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_challenge_workouts(inputs)
	if (locale === "es-419") return es_419_clubs_challenge_workouts(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_challenge_workouts(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_challenge_workouts(inputs)
	if (locale === "de-DE") return de_de2_clubs_challenge_workouts(inputs)
	if (locale === "it-IT") return it_it2_clubs_challenge_workouts(inputs)
	return en_us2_clubs_challenge_workouts(inputs)
});
export { clubs_challenge_workouts as "clubs.challenge_workouts" }